<template>
    <Teleport to="body">
        <div class="modal fade z:$(comment-modal-zindex)! {content:'';fixed:z:$(comment-modal-overlay-zindex);bg:#0000001A;top:0;left:0;w:full;h:full}::before" ref="root" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered adjust-margin">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title f:20!">自訂YT動效</h3>
                        <button class="btn-close" @click="hide" type="button"></button>
                    </div>
                    <div class="modal-body p:24!">
                        <div v-if="switcher(sign).isOpen(0)">
                            <div class="py:60@sm max-w:400 mx:auto t:center@sm">
                                <div class="mb:16">擷取Youtube片段，創造屬於你的迷因或梗圖。</div>
                                <input class="form-control" placeholder="輸入Youtube影片" type="text" v-model="form.url" />
                            </div>
                        </div>
                        <div v-else>
                            <div class="py:8@sm max-w:452 mx:auto">
                                <div class="{max-h:490;mx:auto}>div" v-if="form.video_id">
                                    <yt-player :content="form" controls preview @ready="youtubeReady"></yt-player>
                                </div>
                                <div class="max-w:327 mx:auto">
                                    <div class="mt:48">
                                        <div class="mb:6">設定片段</div>
                                        <input class="w:full" :disabled="form.seconds > 15" :max="form.duration" type="range" v-model="form.begin_time" />
                                    </div>
                                    <div class="mt:16 text:center">
                                        <div class="inline-flex gap:12 ai:baseline ac:center">
                                            <input class="form-control w:75! text:center" readonly type="text" :value="begin" />
                                            <span>-</span>
                                            <input class="form-control w:75! text:center" readonly type="text" :value="end" />
                                            <div class="inline-flex gap:4 ai:baseline">
                                                <span>共</span>
                                                <select class="b:1|#CECECE|solid r:6 w:64 p:4 text:center" v-model="form.seconds">
                                                    <option :key="i" v-for="i in form.max" :value="i">{{ i }}</option>
                                                    <option :value="form.duration">全部</option>
                                                </select>
                                                <span>秒</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt:16">
                                        <div class="text:center">
                                            <input class="form-check-input" id="loopCheck" type="checkbox" v-model="form.loop" />
                                            <label class="form-check-label ml:8" for="loopCheck">
                                                自動循環播放
                                            </label>
                                        </div>
                                    </div>
                                    <div class="mt:16">
                                        <div class="mb:8">此YT動效的搜尋標籤</div>
                                        <input class="form-control" placeholder="請輸入搜尋標籤" type="text" v-model="form.tag" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="w:full flex jc:center gap:24" v-if="switcher(sign).isOpen(0)">
                            <button class="btn btn-outline-secondary color:gray03" @click="hide" type="button">取消</button>
                            <button class="btn btn-primary" @click="next" type="button">下一步</button>
                        </div>
                        <div class="w:full flex jc:center gap:24" v-else>
                            <button class="btn btn-outline-secondary color:gray03" @click="prev" type="button">上一步</button>
                            <button class="btn btn-primary" @click="submit" type="button">確認</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
    const switchStore = new SwitchStore();
    const sign = Symbol();

    let modal;

    const form = reactive({
        begin: 0,
        duration: 0,
        editItem: undefined,
        end: 0,
        video_id: "",
        loop: true,
        max: 0,
        seconds: 0,
        shorts: false,
        tag: "",
        url: ""
    });

    const root = ref();

    const begin = computed(() => {
        return toTime(form.begin_time);
    });

    const end = computed(() => {
        return toTime(form.end_time);
    });

    const emit = defineEmits(["submit"]);

    const getIdFromUrl = (url) => {
        const tokens = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/|\/shorts\/)/);

        return { type: tokens[1], id: (tokens[2] !== undefined) ? tokens[2].split(/[^0-9a-z_\-]/i)[0] : null };
    };

    const hide = () => {
        form.video_id = "";
        modal.hide();
    };

    const next = () => {
        const info = getIdFromUrl(form.url);

        if (info.id) {
            form.editItem = undefined;
            form.video_id = info.id;
            form.begin_time = 0;
            form.duration = 0;
            form.end_time = 0;
            form.loop = true;
            form.shorts = (info.type === "/shorts/") ? true : false;
            form.tag = "";

            switcher(sign).open(1);
        }
    };

    const prev = () => {
        form.video_id = "";
        switcher(sign).open(0);
    };

    const show = () => {
        form.url = "";
        switcher(sign).open(0);
        modal.show();
    };

    const submit = () => {
        const data = {
            video_id: form.video_id,
            begin_time: parseInt(form.begin_time),
            end_time: parseInt(form.end_time),
            loop: form.loop,
            shorts: form.shorts,
            tag: form.tag
        };

        if (form.editItem === undefined) {
            api("api/comment/yt/create", data).done((res) => {
                if (res.success) {
                    hide();
                    emit("submit");
                }
            });
        } else {
            const item = form.editItem;

            data.id = item.id;

            api("api/comment/yt/save", data).done((res) => {
                if (res.success) {
                    item.begin_time = data.begin_time;
                    item.end_time = data.end_time;
                    item.loop = data.loop;
                    item.shorts = data.shorts;
                    item.tag = data.tag;

                    hide();
                }
            });
        }
    };

    const switcher = (name) => switchStore.switcher(name);

    const toTime = (value) => {
        let min = (value >= 600) ? Math.floor(value / 60).toString() : (100 + Math.floor(value / 60)).toString().substring(1);
        let sec = (100 + (value % 60)).toString().substring(1);

        return `${min}:${sec}`;
    };

    const youtubeReady = (duration) => {
        form.duration = duration;

        if (form.editItem === undefined) {
            form.begin_time = 0;
            form.end_time = Math.min(duration, 15);
            form.max = form.end_time;
            form.seconds = form.max;
        } else {
            form.max = Math.min(duration, 15);
            form.seconds = Math.max(duration, parseInt(form.end_time) - parseInt(form.begin_time));
        }
    };

    defineExpose({ hide, show });

    onMounted(() => {
        modal = new bootstrap.Modal(root.value);
    });

    watch(() => [form.begin_time, form.seconds], () => {
        if (form.duration) {
            if (form.seconds > 15) {
                form.begin_time = 0;
                form.end_time = form.duration;
            } else {
                form.end_time = Math.min(parseInt(form.begin_time) + parseInt(form.seconds), form.duration);
            }
        }
    });
</script>
